import {
  forbiddenCharacters,
  validateLength,
} from '../../../../../utility/validation';

export const REPLY_FIELD = {
  name: 'freeText',
  rows: 5,
  isMultiline: true,
  required: false,
  validators: [
    {
      type: 'forbiddenCharacters',
      validator: forbiddenCharacters,
    },
    {
      type: 'maxLength',
      validator: fieldValue => validateLength(fieldValue, 0, 5000),
    },
  ],
};
